export default {"src":"https://static.eleduck.com/_next/static/media/medal-3.6c35eec1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};